module.exports = __webpack_public_path__ + "media/images/flags/4x3/eth-383fca54e1eaaa8ecf8e036d72ac40f7.svg";